import { columnOptions } from "./map-cargo-packing";
import { canModifyDeliveredPackingList } from "@pages/shippingView/helpers/tabs-mapping";

export const TABLET_COLUMNS_PER_GROUP = 5;

/** Pinned first column on tablet while swiping groups. */
export const TABLET_PINNED_COLUMN = "id_number";

export const TABLET_PACKING_COLUMN_WIDTH: Record<string, number> = {
  loading_order: 120,
  id_number: 100,
  status_delivery: 96,
  commodities: 110,
  container: 100,
  net_weight: 88,
  gross_weight: 88,
  customer: 110,
  transport_contractor: 110,
  warehouse: 100,
  pile: 72,
  deposit_reference: 100,
  grade: 72,
  heat: 72,
  fcr_status: 88,
  transport_document: 100,
  actions: 56,
};

export const getTabletPackingColumnWidth = (field: string): number =>
  TABLET_PACKING_COLUMN_WIDTH[field] ?? 90;

export const getTabletOrderedColumns = (visibleColumns: string[]): string[] => {
  const visibleSet = new Set(visibleColumns);
  return columnOptions.map((c) => c.id).filter((id) => visibleSet.has(id));
};

export const getTabletPinnedColumn = (
  visibleColumns: string[],
): string | null => {
  const ordered = getTabletOrderedColumns(visibleColumns);
  if (ordered.length === 0) return null;
  if (ordered.includes(TABLET_PINNED_COLUMN)) return TABLET_PINNED_COLUMN;
  return ordered[0];
};

export const getTabletColumnGroups = (
  visibleColumns: string[],
  columnsPerGroup = TABLET_COLUMNS_PER_GROUP,
): string[][] => {
  const ordered = getTabletOrderedColumns(visibleColumns);
  if (ordered.length === 0) return [[]];

  const pinned = getTabletPinnedColumn(visibleColumns);
  const swipeable = pinned
    ? ordered.filter((col) => col !== pinned)
    : [...ordered];

  const swipeablePerGroup = pinned
    ? Math.max(columnsPerGroup - 1, 1)
    : columnsPerGroup;

  if (swipeable.length === 0) {
    return pinned ? [[pinned]] : [[]];
  }

  const groups: string[][] = [];
  for (let i = 0; i < swipeable.length; i += swipeablePerGroup) {
    const chunk = swipeable.slice(i, i + swipeablePerGroup);
    groups.push(pinned ? [pinned, ...chunk] : chunk);
  }

  return groups;
};

const TABLET_ACTION_BUTTON_SIZE = 28;

export const getTabletPackingActionsColumnWidth = (role: string): number => {
  const canModifyDelivered = canModifyDeliveredPackingList(role);
  let buttonCount = 1;
  if (canModifyDelivered) buttonCount += 1;
  const gap = Math.max(0, buttonCount - 1) * 2;
  return buttonCount * TABLET_ACTION_BUTTON_SIZE + gap + 8;
};
